// Module
var code = "<pre class=\"hidden-print\"><span ng-bind=\"title\"></span> = <span ng-if=\"!model\"><i>null</i></span><json-tree json=\"model\" ng-if=\"model\"></json-tree></pre> ";
// Exports
module.exports = code;